export default __webpack_public_path__ + "static/media/mintAction.b07d7466.svg";